import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import Translation from "../../../../common/translation/translation.component";
import { HistoryLayout } from "../../../../common/history/history-layout.component";
import DisputeDetailsHistory from '../dispute-history/dispute-details-history';
import { disputeHistoryActions } from "../../../../../store/external/invoice/dispute/dispute-history.reducer";

class DisputeHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            enableSearchBox: false,
            extractAlertMsg: "",
        };
        this.onChangeExtractAlertMsg = this.onChangeExtractAlertMsg.bind(this);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    getSelectedIndex(value) {
        this.setState({ selectedIndex: value })
    }

    onClickExtract = () => {
        const { disputeDetailsId, extractDisputeHistoryLogs } = this.props;
        if (window.confirm(this.state.extractAlertMsg)) {
            extractDisputeHistoryLogs(disputeDetailsId);
        }
    }
    onChangeExtractAlertMsg = (val) => {
        this.setState({
            extractAlertMsg: val
        });
    }
    //comment
    render() {
        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />

                <HistoryLayout
                    displaySearchBox={this.displaySearchBox}
                    extractAction={this.onClickExtract}
                    hideCustomColumn={this.props.hideCustomColumn}

                    //Access Type
                    {...this.props.roles}
                >
                        <DisputeDetailsHistory
                        disputeDetailsId={this.props.disputeDetailsId}
                        isColSearchShow={this.state.enableSearchBox}
                        /> 
                </HistoryLayout>

            </>
        )
    }
}
export default connect(
    () => {

        return {
            
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeHistoryActions),
        dispatch
    )
)(DisputeHistory);